import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Building2, Users, Briefcase, FileText, UserSquare2, TrendingUp } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CMSDashboard = () => {
  const { getAuthHeader } = useAuth();
  const [stats, setStats] = useState({
    projects: 0,
    team: 0,
    careers: 0,
    applications: 0,
    inquiries: 0,
    quotes: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const headers = getAuthHeader();
      
      const [projects, team, careers, applications, contacts, quotes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/cms/projects`, { headers }),
        axios.get(`${BACKEND_URL}/api/cms/team`, { headers }),
        axios.get(`${BACKEND_URL}/api/cms/careers`, { headers }),
        axios.get(`${BACKEND_URL}/api/cms/job-applications`, { headers }),
        axios.get(`${BACKEND_URL}/api/contact`, { headers }),
        axios.get(`${BACKEND_URL}/api/cms/quote-requests`, { headers })
      ]);

      setStats({
        projects: projects.data.length,
        team: team.data.length,
        careers: careers.data.filter(c => c.is_active).length,
        applications: applications.data.length,
        inquiries: contacts.data.length,
        quotes: quotes.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Projects', value: stats.projects, icon: Building2, color: 'bg-blue-500' },
    { label: 'Team Members', value: stats.team, icon: Users, color: 'bg-green-500' },
    { label: 'Active Jobs', value: stats.careers, icon: Briefcase, color: 'bg-purple-500' },
    { label: 'Applications', value: stats.applications, icon: FileText, color: 'bg-orange-500' },
    { label: 'Inquiries', value: stats.inquiries, icon: UserSquare2, color: 'bg-pink-500' },
    { label: 'Quote Requests', value: stats.quotes, icon: TrendingUp, color: 'bg-cyan-500' },
  ];

  if (loading) {
    return <div className="text-center py-12">Loading dashboard...</div>;
  }

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.label}
                </CardTitle>
                <div className={`${stat.color} p-3 rounded-lg`}>
                  <Icon className="text-white" size={24} />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-gray-900">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Welcome to CMS Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            Manage your website content, team, projects, and job listings from this dashboard.
            Use the sidebar navigation to access different modules.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CMSDashboard;
